import axios from 'axios'

// Base URL for the API endpoints
const BASE_URL = '/authenticated/supplier'

/**
 * Fetch all Buy-Get-Free promotions for a specific supplier.
 * @param {number} supplierId - The ID of the supplier.
 * @returns {Promise} - Promise resolving to the list of promotions.
 */
export function fetchBuyGetFreePromotions(supplierId) {
  return axios.get(`${BASE_URL}/${supplierId}/buy-get-free-promotions`)
}

export function addBuyGetFreePromotion(supplierId, formData) {
  return axios.post(
    `${BASE_URL}/${supplierId}/buy-get-free-promotions`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

export function updateBuyGetFreePromotion(supplierId, promotionId, formData) {
  return axios.put(
    `${BASE_URL}/${supplierId}/buy-get-free-promotions/${promotionId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data' // ✅ Ensure correct content type
      }
    }
  )
}

/**
 * Delete a Buy-Get-Free promotion.
 * @param {number} supplierId - The ID of the supplier.
 * @param {number} promotionId - The ID of the promotion.
 * @returns {Promise} - Promise resolving when the promotion is deleted.
 */
export function deleteBuyGetFreePromotion(supplierId, promotionId) {
  return axios.delete(
    `${BASE_URL}/${supplierId}/buy-get-free-promotions/${promotionId}`
  )
}

// Export all functions together
export default {
  fetchBuyGetFreePromotions,
  addBuyGetFreePromotion,
  updateBuyGetFreePromotion,
  deleteBuyGetFreePromotion
}
